import axios from "axios";
import Cookies from "js-cookie";
import { CookiesName } from "./common";

const token = Cookies.get(CookiesName);

const axiosClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
  },
});

axiosClient.interceptors.request.use(
  async (config) => {
    try {
      const token = Cookies.get(CookiesName);

      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      } else {
        config.headers["Authorization"] = "";
      }
      // config.headers["origin"] = "https://lmt.widget.sitedata.live:5001";
      // config.headers["referer"] = "https://lmt.widget.sitedata.live:5001";

      //  Referer: "https://lmt.widget.sitedata.live:5001/",
      //   Origin: "https://lmt.widget.sitedata.live:5001",
      return config;
    } catch (error) {
      return Promise.reject(error);
    }
  },
  (err) => {
    return Promise.reject(err);
  }
);

export default axiosClient;
